export default __webpack_public_path__ + "static/media/030_corner1.first.abd7338c.avif";